import React from 'react';
import Type from 'prop-types';
import { IconButton } from "@mui/material";
import { Share as ShareIcon } from "@mui/icons-material";
import { useSnackbar } from 'notistack';
import { useTranslation } from 'hooks';

export const ShareIconButton = (props) => {
  const {
    sharingInfo,
    sharingTitle,
    // eslint-disable-next-line no-unused-vars
    visibility,
    style = undefined,
    size = 'medium',
  } = props;
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  if ('canShare' in navigator === false || !visibility) return null;

  const share = async () => {
    const formattedSharingInfo = {
      title: sharingTitle,
      text: sharingInfo,
    };
    const canShare =
      'canShare' in navigator &&
      (await navigator.canShare(formattedSharingInfo));
    if (canShare) {
      try {
        await navigator.share(formattedSharingInfo);
      } catch (err) {
        if (err.name !== 'AbortError') {
          enqueueSnackbar(err.message || String(err), { variant: 'error' });
        }
      }
    } else {
      enqueueSnackbar(
        'Ваш телефон не поддерживает функцию шаринга в другие программы',
        { variant: 'error' },
      );
    }
  };

  return (
    <IconButton
      color="primary"
      aria-label={t('toShare')}
      onClick={share}
      className={style}
      size={size}
    >
      <ShareIcon />
    </IconButton>
  );
};

ShareIconButton.propTypes = {
  sharingInfo: Type.string.isRequired,
  sharingTitle: Type.string.isRequired,
  visibility: Type.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types, react/require-default-props
  style: Type.any,
  size: Type.oneOf(['small', 'medium']).isRequired,
};
